<template>
    <div class="blick-comp">
        <div ref="blick" class="blick">

        </div>
    </div>
</template>

<script>

  export default {
    data(){
      return {
      }
    },
    components: {
    },
    methods: {
      //public
      animate(){
        this.$refs.blick.classList.add('blick--mod-animation');
        setTimeout(()=>{
          this.$refs.blick.classList.remove('blick--mod-animation');
        },500)

      },

    },
    mounted(){

    }
  }
</script>
<style scoped lang="scss">
    .blick-comp{
      /*border: 1px solid darkred;*/
      pointer-events: none;
      @keyframes move {
        from {
          left: 0%;
          opacity:0;
        }
        to {
          opacity:1;
          left:150%;
        }
      }
      .blick--mod-animation {
        animation: move;
        animation-duration: 500ms;
        animation-timing-function: cubic-bezier(.62,0,.99,.67);
      }
      .blick {
        --blickWidth: calc(var(--sizeCell) * 2);
        position: absolute;
        width: var(--blickWidth);
        height: 100%;
        transform: skew(-15deg);
        transform-origin: right top;
        background-color: rgba(white, 0.3);
        left: 0%;
        opacity:0;
        filter: blur(calc( 2 * var(--px)));
        z-index: 1;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/blick-comp.vue